import React, { useContext } from "react";
import { Button, Tooltip } from "antd";
import { FaFileAlt } from "react-icons/fa";
import language from "../../resources/languages/fa_IR";
import { ActionType, Enum } from '../../resources/constants';

// Contexts
import GlobalContext from "../../contexts/global";

const { Components: { Request } } = language
const { SET_OPEN_DRAWER, SET_FORM } = ActionType
const { Form } = Enum

export default function Index() {

    const { openDrawer, isOpenFloatButton, user, dispatch } = useContext(GlobalContext)

    return (
        <Tooltip placement="top" title={Request.request} overlayClassName={'button-tooltip'} open={!openDrawer && !isOpenFloatButton}>
            <Button type="primary" shape="round" icon={<FaFileAlt size={30} />} size={'large'} onClick={() => {
                dispatch({ type: SET_FORM , payload: { form: user ? Form.REQUEST : Form.SIGN_IN }})
                dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
            }} />
        </Tooltip>
    );
};
